import styled from 'styled-components';

export const Wrapper = styled.div<{
  $height: number;
  $backgroundColor: string;
  $borderRadius: number;
}>`
  display: flex;
  width: 100%;
  height: ${({ $height }) => `${$height}px`};
  overflow: hidden;
  background-color: ${({ $backgroundColor }) => $backgroundColor};
  border-radius: ${({ $borderRadius }) => `${$borderRadius}px`};
`;

export const SegmentItem = styled.div<{
  $width: number;
  $color: string;
}>`
  width: ${({ $width }) => `${$width}%`};
  height: 100%;
  background-color: ${({ $color }) => $color};
  transition: width 0.2s ease;
`;
